/**
 * Environment configuration for the 'test' server.
 *
 * The setting 'dateFormat' is set to 'Moment date format'.
 * For more information: https://momentjs.com/docs/#/displaying/format/
 */
export const environment = {
    env: 'test',
    application: 'CRM',
    production: false,
    tenant: 1,
    filesApiUrl: 'https://file-test.alaricsecurities.net/api/v1/',
    crmApiUrl: 'https://crm-api-test.alaricsecurities.net/api/v1/',
    crmBaseApiUrl :  'https://crm-api-test.alaricsecurities.net/api/',
    sesApiUrl: 'https://ses-test.alaricsecurities.net/api/v3/',
    amsApiUrl: 'https://ams-test.alaricsecurities.net/api/',
    reportingNetBaseApiUrl: 'https://rpt-test-onprem.alaricsecurities.net/api/',
    fundOrdersApiUrl: 'https://alaric-fund-orders-test.alaricsecurities.net/api/v1/',
    auditApiUrl: 'https://audit-test.alaricsecurities.net/api/v1/',
    cdnUrl: 'https://cdn-test.alaricsecurities.net/',
    fundamentalApiUrl: 'https://fundamental-test.alaricsecurities.net/api/',
    payGatewayUrl: 'https://pay-test.alaricsecurities.net/api/v1/',
    closeOutApiUrl: 'https://closeout-test.alaricsecurities.net/api/',

    authId: 'CrmPortal',
    authUrl: 'https://auth-test.alaricsecurities.net',
    authRedirectUrl: 'https://crm-test.alaricsecurities.net/panel/dashboard',
    authResetPasswordRedirectUrl: 'https://auth-test.alaricsecurities.net/Account/ResetPasswordPage?Client=',
    authScopes: [
        'roles',
        'TokenserverAPI.write',
        'TokenserverAPI.read',
        'tenant',
        'offline_access',
        'Alaric.FileStorage',
        'Alaric.Payment',
        'IdentityServerApi',
        'two_factor_enabled',
        'phone',
        'Alaric.Audit',
        'Alaric.AccountChargeScheduler',
        'Alaric.Recipient',
        'Alaric.Subscription',
        'Alaric.Entitlement',
        'Alaric.Reporting',
        'Alaric.CRM',
        'Alaric.FundOrders',
        'Alaric.MS',
        'openid',
        'profile',
        'email',
        'Alaric.Fundamental'
    ].join(' '),

    authClientStorageKey: 'oidc.user:https://auth-test.alaricsecurities.net:CrmPortal',

    customCacheResponseHeader: 'X-Cacheable-Response',
    customProtectedApiHeader: 'X-Protected-Api',
    authEnableAutomaticSilentRenew: true,
    authDisableSessionMonitoring: true,

    useBugsnag: true,
    bugsnagApiKey: 'b3b8234d40d5bf0219f7c9f3ae7eaff3',

    useStorage: true,
    storageTtl: 3600000,

    randomGeneratedStorageCollectionKey: 'rpv9v14e2aplmhkhj4prgwq5ygzlao65',
    randomGeneratedAwaitLoginKey: 'b4e982108522e97a6e8b1ca347d39278',

    dateFormat: 'MM/DD/YY',
    dateTimeFormat: 'MM/DD/YY HH:mm:ss',
    dateTimeFormatTimeZone: 'YYYY-MM-DDTHH:mm:ss.SSS[Z]',
    dateFormatShort: 'dd/MM/yyyy',
    timeFormat: 'HH:mm:ss',
    onlyYearDateFormat: 'YYYY',
    dateFormatLocalDate: 'YYYY-MM-DD',
    featureFlagEnvironmentKey: '3HSPtRdCBP3jDytkWxxdcj',

    features: {
        'crm.tradingPlans': false
    }
};
